import { all, call, put, takeLatest } from 'redux-saga/effects'
import SoundEffectActions, { SoundEffectTypes } from 'Redux/SoundEffectRedux'

// Default categories
const DEFAULT_CATEGORIES = [
  'ambient', 'nature', 'music', 'ui', 'foley', 'impact',
  'whoosh', 'transition', 'voice', 'animal', 'weather', 'urban'
]

// Search Sound Effects
export function* searchSoundEffects(api, action) {
  try {
    const { query, options } = action
    const resp = yield call(api.searchSoundEffects, query, options)

    if (resp.ok) {
      yield put(SoundEffectActions.soundEffectsSearchSuccess(resp.data?.sound_effects || []))
    } else {
      const error = resp.data?.error || 'Failed to search sound effects'
      yield put(SoundEffectActions.soundEffectsSearchFailure(error))
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to search sound effects'
    yield put(SoundEffectActions.soundEffectsSearchFailure(errorMsg))
  }
}

// Get Categories
export function* getCategories(api, action) {
  try {
    const resp = yield call(api.getSoundEffectCategories)

    if (resp.ok && resp.data?.categories) {
      yield put(SoundEffectActions.soundEffectsCategoriesSuccess(resp.data.categories))
    } else {
      // Use default categories
      yield put(SoundEffectActions.soundEffectsCategoriesSuccess(DEFAULT_CATEGORIES))
    }
  } catch (error) {
    // Use default categories on error
    yield put(SoundEffectActions.soundEffectsCategoriesSuccess(DEFAULT_CATEGORIES))
  }
}

// Get Video Sound Effect Clips
export function* getClips(api, action) {
  try {
    const resp = yield call(api.getVideoSoundEffectClips, action.videoId)

    if (resp.ok) {
      yield put(SoundEffectActions.soundEffectClipsGetSuccess(resp.data || []))
    } else {
      const error = resp.data?.error || 'Failed to get sound effect clips'
      yield put(SoundEffectActions.soundEffectClipsGetFailure(error))
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to get sound effect clips'
    yield put(SoundEffectActions.soundEffectClipsGetFailure(errorMsg))
  }
}

// Add Sound Effect Clip
export function* addClip(api, action) {
  try {
    const { videoId, clipData } = action
    const resp = yield call(api.addSoundEffectClip, videoId, clipData)

    if (resp.ok) {
      yield put(SoundEffectActions.soundEffectClipAddSuccess(resp.data))
    } else {
      const error = resp.data?.error || 'Failed to add sound effect clip'
      yield put(SoundEffectActions.soundEffectClipAddFailure(error))
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to add sound effect clip'
    yield put(SoundEffectActions.soundEffectClipAddFailure(errorMsg))
  }
}

// Update Sound Effect Clip
export function* updateClip(api, action) {
  try {
    const { videoId, clipId, updates } = action
    const resp = yield call(api.updateSoundEffectClip, videoId, clipId, updates)

    if (resp.ok) {
      yield put(SoundEffectActions.soundEffectClipUpdateSuccess(resp.data))
    } else {
      const error = resp.data?.error || 'Failed to update sound effect clip'
      yield put(SoundEffectActions.soundEffectClipUpdateFailure(error))
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to update sound effect clip'
    yield put(SoundEffectActions.soundEffectClipUpdateFailure(errorMsg))
  }
}

// Delete Sound Effect Clip
export function* deleteClip(api, action) {
  try {
    const { videoId, clipId } = action
    const resp = yield call(api.deleteSoundEffectClip, videoId, clipId)

    if (resp.ok) {
      yield put(SoundEffectActions.soundEffectClipDeleteSuccess())
    } else {
      const error = resp.data?.error || 'Failed to delete sound effect clip'
      yield put(SoundEffectActions.soundEffectClipDeleteFailure(error))
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to delete sound effect clip'
    yield put(SoundEffectActions.soundEffectClipDeleteFailure(errorMsg))
  }
}

// Watcher saga
export default function* soundEffectSaga(api) {
  yield all([
    takeLatest(SoundEffectTypes.SOUND_EFFECTS_SEARCH_REQUEST, searchSoundEffects, api),
    takeLatest(SoundEffectTypes.SOUND_EFFECTS_CATEGORIES_REQUEST, getCategories, api),
    takeLatest(SoundEffectTypes.SOUND_EFFECT_CLIPS_GET_REQUEST, getClips, api),
    takeLatest(SoundEffectTypes.SOUND_EFFECT_CLIP_ADD_REQUEST, addClip, api),
    takeLatest(SoundEffectTypes.SOUND_EFFECT_CLIP_UPDATE_REQUEST, updateClip, api),
    takeLatest(SoundEffectTypes.SOUND_EFFECT_CLIP_DELETE_REQUEST, deleteClip, api),
  ])
}
